import dateOptions from 'constants/dateOptions';
import countries from 'constants/countries';

export const epochToISOFormat = (epoch, fullFormat) => {
  const isoString = dateToLocalISO(epoch);
  return !fullFormat ? isoString.slice(0, 10) : isoString;
};

const dateToLocalISO = (date) => {
  const off = new Date(date).getTimezoneOffset();
  return new Date(new Date(date).getTime() - off * 60 * 1000).toISOString();
};

export const setDateFormat = (date, country) => {
  let locale;
  switch (country) {
    case countries.US:
      locale = 'en-US';
      break;
    case countries.UK:
      locale = 'en-UK';
      break;
    case countries.EU:
      locale = 'en-US';
      break;
    case countries.FR:
      locale = 'FR';
      break;
    case countries.DE:
      locale = 'DE';
      break;
    default:
      locale = 'en-US';
  }
  return new Date(date).toLocaleString(locale, dateOptions);
};

export const dateParse = (date) => (date && Date.parse(date)) || 0;

export const dateToString = (date) => !!date && new Date(date).toString();

export const dateDifferenceInHours = (date1, date2) => Math.abs(date1 - date2) / 36e5;